// extracted by mini-css-extract-plugin
export default {"semibold":"TeacherQuestionItem__semibold___gBOSg fonts__whitney-semibold___M7vMo"};